import {AsyncPipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {
    AbstractControl,
    ReactiveFormsModule,
    UntypedFormControl,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {Client, ClientService} from '@app/admin/client.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'frog-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatFormField,
        MatInput,
        ReactiveFormsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
    ],
})
export class DeleteDialogComponent implements OnInit {
    public confirmControl: UntypedFormControl;
    public client$: Observable<Client>;

    private workspaceName: string;

    constructor(
        private clientService: ClientService,
        public dialogRef: MatDialogRef<DeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: boolean,
    ) {
        this.confirmControl = new UntypedFormControl('', [
            Validators.required,
            this.nameMatchValidator(),
        ]);
    }

    ngOnInit(): void {
        this.client$ = this.clientService.client.pipe(
            tap((client) => (this.workspaceName = client.config.data.name)),
        );
    }

    confirm(): void {
        if (this.confirmControl.value === this.workspaceName) {
            this.dialogRef.close(true);
        } else {
            this.dialogRef.close(false);
        }
    }

    nameMatchValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value === this.workspaceName
                ? null
                : { nameMatch: { value: control.value } };
        };
    }
}
